import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EXCLUSIVE } from "@/data/news";

export default function DenvaExclusive({ items }) {
  const data = items && items.length ? items : EXCLUSIVE;
  return (
    <section
      id="exclusive"
      data-testid="exclusive-section"
      className="relative bg-[#0A0A0A] text-[#F4F4F0] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-20 md:py-28 relative">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
          <div>
            <div className="eyebrow text-[#D92525] mb-4">देनवा एक्सक्लूसिव</div>
            <h2 className="font-serif-dev font-black text-[40px] md:text-[64px] leading-[1] max-w-[900px]">
              वे कहानियाँ जो <span className="italic text-[#D92525]">कहीं और नहीं</span> मिलेंगी।
            </h2>
            <p className="mt-5 font-sans-dev text-[15px] md:text-[16px] text-white/60 max-w-[560px]">
              हमारी संपादकीय टीम की खोजी रिपोर्टें, लम्बी पड़तालें और ज़मीनी दस्तावेज़—एक जगह।
            </p>
          </div>
          <a href="/category/exclusive" data-testid="exclusive-all" className="font-sans-dev text-[12px] tracking-[0.24em] uppercase text-white/80 link-underline">
            सारी एक्सक्लूसिव →
          </a>
        </div>

        <div className="space-y-14 md:space-y-20">
          {data.map((e, i) => (
            <motion.a
              key={e.n}
              href={e.slug ? `/news/${e.slug}` : "#"}
              data-testid={`exclusive-${e.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className={`group block relative ${i === 1 ? "md:pl-[10%]" : ""} ${i === 2 ? "md:pl-[20%]" : ""}`}
            >
              <div className="grid grid-cols-12 items-start gap-6 md:gap-10 border-t border-white/15 pt-8 md:pt-12">
                <div className="col-span-12 md:col-span-3 relative">
                  <div className="num-outline font-serif-dev font-black text-[140px] md:text-[200px] leading-[0.8] select-none pointer-events-none">
                    {e.n}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-9 md:pl-4">
                  <div className="eyebrow text-[#D92525] mb-4">{e.kicker}</div>
                  <h3 className="font-serif-dev font-bold text-[26px] md:text-[38px] leading-[1.15] max-w-[820px]">
                    <span className="headline-link transition-colors">{e.title}</span>
                  </h3>
                  <p className="mt-5 font-sans-dev text-[15px] md:text-[17px] text-white/70 leading-relaxed max-w-[720px]">
                    {e.excerpt}
                  </p>
                  <div className="mt-6 flex items-center justify-between flex-wrap gap-3">
                    <span className="font-sans-dev text-[11px] tracking-[0.28em] uppercase text-white/50">
                      रिपोर्ट · {e.author}
                    </span>
                    <span className="inline-flex items-center gap-2 text-[13px] uppercase tracking-[0.22em] text-white/80 group-hover:text-[#D92525] transition-colors">
                      पूरी रिपोर्ट <ArrowUpRight size={16} />
                    </span>
                  </div>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>

      {/* subtle grain */}
      <div className="grain absolute inset-0 pointer-events-none" />
    </section>
  );
}
